import { FunctionComponent } from 'react'

import { RootStackScreenComponentProps } from 'src/navigation'

export type LockscreenScreenComponent = FunctionComponent<LockscreenScreenProps>

export type LockscreenScreenProps = RootStackScreenComponentProps<'Lockscreen'>

export type ResponsiveLockscreenScreenComponent = FunctionComponent<ReturnType<UseLockscreenScreen>>

export enum LockscreenTimeOptions {
  IMMEDIATELY = 0,
  ONE_MINUTE = 1,
  FIFTEEN_MINUTES = 15,
  ONE_HOUR = 60
}

export type UseLockscreenScreen = ({ navigation }: Pick<LockscreenScreenProps, 'navigation'>) => {
  isMobile: boolean
  unlock: boolean
  requestUnlock: (item: boolean) => void
  unlockTime: LockscreenTimeOptions
  handleUnlockTime: (item: LockscreenTimeOptions) => void
  listOfTimes: number[]
}
